import { Button, ButtonsGroup, Heading, Icon, InputSelect, InputSelectChange, PageHeader, Typo } from "#/atoms";
import { CustomTable, FilterAction } from "#/molecules";
import { DESKTOP_SPACING, FONT_SIZE, NATURAL, PRIMARY_BLUE } from "@/theme";
import { FC, memo, useCallback, useState } from "react";

import { Column } from "react-table";
import { GenerateInvoicesProps } from "./GenerateInvoices.interface";
import { PageWrapper } from "#/atoms";
import { formatShortDateString } from "@/helpers";

const GenerateInvoices: FC<GenerateInvoicesProps> = ({ loading, numberOfFilters, onGenerate, onOpenFilter, orders }) => {
  
  const [invoicesToGenerate, setInvoicesToGenerate] = useState<string[]>([]);
  
  const handleSelectAll = () => {
    if (invoicesToGenerate.length === orders.length) {
      setInvoicesToGenerate([]);
    } else {
      setInvoicesToGenerate(orders.map((order) => order.id));
    }
  }

  const handleInputChange: InputSelectChange = useCallback((isChecked, value) => {
    if (isChecked) {
      setInvoicesToGenerate([...invoicesToGenerate, value])
    } else {
      setInvoicesToGenerate(invoicesToGenerate.filter((item) => item !== value));
    }
  }, [invoicesToGenerate]);

  const getChecked = useCallback((val: string) => {
    return invoicesToGenerate.includes(val);
  }, [invoicesToGenerate]);
  
  const handleGenerate = useCallback(async (e) => {
    
    if (invoicesToGenerate.length == 0) {
      return;
    }
    e.target.disabled = true;
    
    await onGenerate(invoicesToGenerate)

    setInvoicesToGenerate([]);

    e.target.disabled = false;
  }, [invoicesToGenerate]);

  const getColumns = () => {
    const cols : Column[] = [
      {
          Cell: (props) => ( <>
            <InputSelect
              type="checkbox"
              checked={getChecked(props.value)}
              name="invoices"
              value={props.value}
              onChangeValue={(checked, value) => handleInputChange(checked, value)}
            />
            <p style={{display: 'inline'}}>{props.value}</p>
            </>
          ),
          Header: '',
          accessor: 'id',
        },
        {
          Header: 'Job',
          accessor: 'title',
        },
        {
          Header: 'Company',
          accessor: 'companyName',
        },
        {
          Cell: ({ value }) => (
                  <p> { formatShortDateString(value) }</p>
                ),
          Header: 'WorkDate',
          accessor: 'workdate',
        },
        {
          Header: 'Price',
          accessor: 'price',
        },
      ] 

    return cols;
  }


  return (
    <PageWrapper>
      <PageHeader>
        <Heading scale="h1" fontColor={NATURAL.K}>Orders Ready to be Invoiced</Heading>
        <Typo fontColor={NATURAL.G} fontSize={FONT_SIZE.SM}>Invoices will go to your Xero Account</Typo>
        <ButtonsGroup>
          <Button onClick={handleSelectAll}>{ invoicesToGenerate.length === orders.length ? 'Deselect All' : 'Select All'}</Button>
          <Button onClick={handleGenerate}>Generate Invoices</Button>
        </ButtonsGroup>
      </PageHeader>
      <Typo display="flex" fontColor={NATURAL.G} fontSize={FONT_SIZE.SM} margin={`0 0 ${DESKTOP_SPACING.SM}px 0`}>
        <Icon type="info" fillColor={PRIMARY_BLUE.DARK} />
        You can send max 50 orders at a time, the process may take up to 2 mins
      </Typo>
      <Typo display="flex" fontColor={NATURAL.G} fontSize={FONT_SIZE.SM}>
        <Icon type="info" fillColor={PRIMARY_BLUE.DARK} />
        System loads 50 orders per page, to upload more you can scroll down
      </Typo>
      <FilterAction numberOfFilters={numberOfFilters} onOpen={onOpenFilter} />
      <Heading scale="h2" fontColor={NATURAL.K}>Invoices to send</Heading>
      <CustomTable columns={getColumns()} data={orders}   loading={loading} pagination={{ pageIndex: 0, pageSize: 50 }} />
    </PageWrapper>
  );
};

export default memo(GenerateInvoices);
